<template>
  <div class="managePet px-4">
    <h2 class="main-title">
      {{ $route.query.id ? "Izmeni životinju" : "Dodaj životinju" }}
    </h2>
    <div class="main-container">
      <v-card class="reset-password-container" elevation="0">
        <v-form
          class="my-form-container-new-owner"
          ref="managePetForm"
          v-model="validForm"
          lazy-validation
        >
          <div>
            <v-text-field
              label="Ime"
              v-model="petInfo.name"
              @keyup.enter="managePet()"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Vrsta"
              v-model="petInfo.type"
              @keyup.enter="managePet()"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Rasa"
              v-model="petInfo.breed"
              @keyup.enter="managePet()"
              outlined
              dense
            ></v-text-field>
            <v-radio-group v-model="petInfo.gender" row class="mt-0">
              <v-radio label="Muški" value="Muški" color="orange"></v-radio>
              <v-radio label="Ženski" value="Ženski" color="orange"></v-radio>
            </v-radio-group>
            <div>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Datum rodjenja"
                    class="text--white"
                    readonly
                    outlined
                    dense
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="closeDateMenu">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <v-text-field
              label="Broj pasoša"
              v-model="petInfo.passportNo"
              @keyup.enter="managePet()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Mikro čip ID"
              v-model="petInfo.microChipNo"
              @keyup.enter="managePet()"
              outlined
              dense
            ></v-text-field>
            <div>
              <v-btn
                elevation="0"
                block
                color="text--white teal darken-2"
                @click="managePet()"
              >
                {{ lang == "en" ? "ADD" : "SAČUVAJ" }}
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "managePet",
  data() {
    return {
      date: null,
      menu: false,
      validForm: false,
    };
  },
  computed: {
    ...mapState(["lang", "petInfo", "snackbar"]),
    ...mapGetters(["rules"]),
    passwordConfirmationRule() {
      return [
        (value) =>
          !!value || (this.lang == "en" ? "Required" : "Obavezno polje"),
        this.password.new === this.password.newConfirm ||
          (this.lang == "en"
            ? "New passwords must match"
            : "Nove lozinke se moraju poklapati"),
      ];
    },
  },
  mounted() {
    this.setupForm();
  },
  methods: {
    closeDateMenu () {
      this.menu = ''
      this.date = null
      this.$refs.menu.save(this.date)
    },
    setupForm() {
      if (this.$route.query.id) {
        this.$store.dispatch("getPet", this.$route.query.id);
      }
      if (this.$route.query.idOwner) {
        this.$store.state.petInfo = {
          ownerId: parseInt(this.$route.query.idOwner),
          name: "",
          surname: "",
          jmbg: "",
          email: "",
          mobilePhone: "",
          phone: "",
          address: "",
          lk: "",
        };
      }
    },
    updatePet() {
      this.$store.dispatch("updatePet", this.$route.query.id);
    },
    insertPet() {
      this.$store.dispatch("insertPet", this.$route.query.idOwner);
    },
    managePet() {
      if (this.$refs.managePetForm.validate()) {
        if (this.$route.query.id) {
          this.updatePet();
        } else {
          this.insertPet();
        }
        this.edit = false;
      }
    },
  },
  watch: {
    "$route.query"() {
      this.setupForm();
    },
    date(newValue) {
      if (newValue) {
        this.$store.state.petInfo.dateOfBirth = newValue;
      }
    },
    "$store.state.petInfo"() {
      this.date = this.$store.state.petInfo.dateOfBirth;
    }
  },
};
</script>

<style lang="scss">
.theme--light.v-label {
  color: #8b8b8b !important
}
.v-input--selection-controls .v-radio > .v-label {
  color: #8b8b8b !important;
}
.my-form-container-new-owner {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  > div:nth-child(1) {
    flex: 0 0 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      display: flex;
      flex: 0 0 49%;
    }
  }
}
</style>